import gql from 'graphql-tag'

export default gql`
  subscription onCreateChatLog($workflowId: ID!) {
    onCreateChatLog(workflowId: $workflowId) {
      id
      workflowId
      type
      content
      userId
      aiOutput
      createdAt
    }
  }
`
